
<mat-dialog-content>
  <span mat-dialog-title>Previous feedback </span>
  <div class="feedback-box">
    <ul *ngIf="feedbackList.data && feedbackList.data.length; else noFeedback">
      <li *ngFor="let item of feedbackList.data">
        <div class="feedback-text">{{ item.feedback }}</div>
        <div class="feedback-timestamp">On: {{ item.timestamp | date:'medium' }}</div>
        <div class="feedback-by">By:{{ item.updated_by }}</div>
        <hr>
      </li>
    </ul>
    <ng-template #noFeedback>
      <div>No previous feedback available.</div>
    </ng-template>
  </div>
  <mat-dialog-actions>
    <button mat-button class="cra-button button-dark" mat-dialog-close cdkFocusInitial>Close</button>
  </mat-dialog-actions>
</mat-dialog-content>

